<template>
  <div>
    <h3 class="text-center font-weight-bold pb-3"><span class="color-lightpink pr-2">{{count}}</span> Kudos received</h3>
    <hr />
    <kudos-list
      :loading="loading"
      :kudos="kudosFiltered"
      :received="received"
      :selectable="false"
      class="pt-3"
    />
  </div>
</template>

<script>
import KudosList from './KudosList.vue'
import { kudosQuery } from '@/helpers/helpers'
import { KUDO_SELECT_TYPE } from '@/helpers/types'

export default {
  name: 'KudosReceived',

  props: {
    kudos: {
      type: Array
    },

    received: {
      type: Array
    },

    loading: {
      type: Boolean
    }
  },

  computed: {
    kudosFiltered() {
      return kudosQuery(this.kudos || [], this.received, '', KUDO_SELECT_TYPE.RECEIVED)
    },

    count() {
      return (this.received || []).reduce((out, value) => out + value.count, 0)
    }
  },

  components: {
    KudosList
  }
}
</script>
